/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description IntegratedTourType
 */

export enum IntegratedTourType {
  /** Agent is in-person showing potential tenant around property */
  AGENT_GUIDED = 1,
  /** Agent is showing potential tenant the property via live video communication */
  LIVE_VIRTUAL = 2,
  /** Potential tenant is in-person showing themself the property */
  SELF_GUIDED = 3,
}

Object.defineProperty(IntegratedTourType, '__ENUM_NAME', {
  value: 'IntegratedTourType',
  writable: false,
  configurable: false,
  enumerable: false,
})
